export default __webpack_public_path__ + "static/media/mail.0933fe4f.png";